import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import RegisteredLayerTree from "./registeredLayerTree";
import AddServicePanel from "./addServicePanel";
import { key, trans } from "../../lib/utils";

function LayerManager() {
  const [activeTab, setActiveTab] = useState("tab-1");

  const [tab1Content, setTab1Content] = useState(null);

  useEffect(() => {}, []);

  return (
    <div className="w-100" style={{ height: "calc(100vh - 16rem)" }}>
      <ul className="nav nav-tabs navbar-expand small">
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis  ".concat(
              activeTab == "tab-1" ? "active" : ""
            )}
            onClick={() => {
              setActiveTab("tab-1");
            }}
          >
            <span className="color-black">{trans("Available layers")}</span>
          </span>
        </li>
        <li className="nav-item " role="button">
          <span
            className={"nav-link color-strong-grey nav-ellipsis ".concat(
              activeTab == "tab-2" ? "active" : ""
            )}
            onClick={() => {
              setActiveTab("");
              setActiveTab("tab-2");
            }}
          >
            <span className="color-black">{trans("Add source")}</span>
          </span>
        </li>
      </ul>
      <div className="tab-content ">
        <div
          className={"tab-pane fade  ".concat(
            activeTab == "tab-1" ? "show active" : ""
          )}
          id={"tab-1"}
          role="tabpanel"
          aria-labelledby={"tab-1"}
        >
          <div className="d-flex">
            <div className="h-100" style={{ width: "30rem" }}>
              <RegisteredLayerTree
                setContent={setTab1Content}
              ></RegisteredLayerTree>
            </div>
            <div className="h-100 w-100">{tab1Content}</div>
          </div>
        </div>
        <div
          className={"tab-pane fade  ".concat(
            activeTab == "tab-2" ? "show active" : ""
          )}
          id={"tab-2"}
          role="tabpanel"
          aria-labelledby={"tab-2"}
        >
          <AddServicePanel key={key()}></AddServicePanel>
        </div>
      </div>
    </div>
  );
}

export default LayerManager;
